// EQ-XXX
// Barra unificada de "doble hito" de carrito (envío gratis + regalo gratis).
// Sustituye a component-shipping-notice.js (EQ-218) y fusiona/extiende
// component-cart-gifting.js (EQ-413/433/437) en un único archivo.

function cartRewardsFormatMoney(cents, format) {

  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number === null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      '$1' + thousands
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount + KROWN.settings.iso_code;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'");
      break;
  }

  return formatString.replace(placeholderRegex, value);

}

if (typeof CartRewardsBar !== 'function') {

  // Margen mínimo, en PUNTOS PORCENTUALES de la barra (0-100), que se fuerza
  // entre el punto de posición y cualquier icono de hito. Si el punto real
  // cae a menos de este margen de un icono, se coloca exactamente a esa
  // distancia (antes o después, según de qué lado venga). El punto nunca
  // se oculta.
  //
  // Ajustable en vivo desde la consola mientras se prueba, llamando:
  //   setCartRewardsDotGap(5)
  // Repinta al instante todas las barras de la página con ese margen y
  // devuelve el valor aplicado. Llamarla varias veces con el MISMO número
  // no debería mover nada (el punto ya estaría en esa posición). Una vez
  // decidido el valor final, sustituir el "5" de abajo por ese número y
  // quitar setCartRewardsDotGap.
  let cartRewardsDotMargin = 6;

  window.setCartRewardsDotGap = function (marginPct) {
    cartRewardsDotMargin = Number(marginPct);
    document.querySelectorAll('cart-rewards-bar').forEach(bar => {
      if (typeof bar.render === 'function') bar.render();
    });
    return cartRewardsDotMargin;
  };

  class CartRewardsBar extends HTMLElement {

    connectedCallback() {
      this.textEl = this.querySelector('[data-js-rewards-text]');
      this.sliderEl = this.querySelector('[data-js-rewards-slider]');
      this.dotEl = this.querySelector('[data-js-rewards-dot]');
      this.giftIconEl = this.querySelector('[data-js-icon-gift]');
      this.shippingIconEl = this.querySelector('[data-js-icon-shipping]');
      this.mode = this.dataset.mode;
      this.useCustomMessage = this.textEl && this.textEl.getAttribute('custom-message') === 'true';
      this.currencyRate = (window.Shopify && Shopify.currency && Shopify.currency.rate) ? Number(Shopify.currency.rate) : 1;

      this.tShipping = Math.round(Number(this.dataset.shippingThreshold) * this.currencyRate);
      this.tGift = Math.round(Number(this.dataset.giftThreshold) * this.currencyRate);
      this.subtotal = Number(this.dataset.subtotal);
      this.cartTotal = Number(this.dataset.cartTotal);

      // Escala única de la barra: el hito de mayor importe representa el 100%.
      if (this.mode === 'gift_only') {
        this.tMax = this.tGift;
      } else if (this.mode === 'shipping_only') {
        this.tMax = this.tShipping;
      } else {
        this.tMax = Math.max(this.tShipping, this.tGift);
      }

      // Posición fija (en %) de cada icono sobre la barra, ya calculada en
      // Liquid vía "left" inline; se lee de vuelta para la lógica de colisión.
      this.giftIconPct = this.giftIconEl ? parseFloat(this.giftIconEl.style.left) : null;
      this.shippingIconPct = this.shippingIconEl ? parseFloat(this.shippingIconEl.style.left) : null;

      this.render();

      this._cartUpdatedHandler = (e) => {
        setTimeout(() => this.refresh(e.detail), 100);
      };
      document.addEventListener('cart:updated', this._cartUpdatedHandler);
    }

    disconnectedCallback() {
      if (this._cartUpdatedHandler) {
        document.removeEventListener('cart:updated', this._cartUpdatedHandler);
      }
    }

    async refresh(cartDetail) {
      let cart = cartDetail;
      if (!cart || !cart.items) {
        try {
          const response = await fetch(window.Shopify.routes.root + 'cart.js');
          cart = await response.json();
        } catch (error) {
          return;
        }
      }

      this.subtotal = cart.items.reduce((total, item) => {
        if (item.properties && item.properties._gift_product === 'true') {
          return total;
        }
        return total + item.final_line_price;
      }, 0);
      this.cartTotal = cart.total_price;

      this.render();
    }

    render() {
      if (this.mode === 'shipping_only') {
        this.renderShippingOnly();
      } else if (this.mode === 'gift_only') {
        this.renderGiftOnly();
      } else if (this.mode === 'both') {
        this.renderBoth();
      }
      this.updateProgress();
    }

    // Modo legado (EQ-218): idéntico al comportamiento previo a esta feature.
    renderShippingOnly() {
      const remaining = this.cartTotal - this.tShipping;

      if (remaining < 0) {
        if (this.useCustomMessage) {
          this.setText(KROWN.settings.locales.cart_custom_message.replace('{{amount}}', cartRewardsFormatMoney(Math.abs(remaining), KROWN.settings.shop_money_format)));
        } else {
          this.setText(KROWN.settings.locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', cartRewardsFormatMoney(Math.abs(remaining), KROWN.settings.shop_money_format)));
        }
      } else {
        if (this.useCustomMessage && KROWN.settings.locales.cart_custom_message_final) {
          this.setText(KROWN.settings.locales.cart_custom_message_final);
        } else {
          this.setText(KROWN.settings.locales.shipping_notice_eligible_for_free);
        }
      }
    }

    renderGiftOnly() {
      const remaining = this.subtotal - this.tGift;

      if (remaining < 0) {
        this.setText(KROWN.settings.locales.cart_gift_remaining_html.replace('{{ remaining_amount }}', cartRewardsFormatMoney(Math.abs(remaining), KROWN.settings.shop_money_format)));
      } else {
        this.setText(KROWN.settings.locales.cart_gift_eligible);
      }
    }

    renderBoth() {
      const remShipping = this.subtotal - this.tShipping;
      const remGift = this.subtotal - this.tGift;
      const shippingDone = remShipping >= 0;
      const giftDone = remGift >= 0;

      if (!shippingDone && !giftDone) {
        if (this.tShipping === this.tGift) {
          this.setText(KROWN.settings.locales.cart_both_remaining_combined_html.replace('{{ remaining_amount }}', cartRewardsFormatMoney(Math.abs(remShipping), KROWN.settings.shop_money_format)));
        } else if (Math.abs(remShipping) <= Math.abs(remGift)) {
          if (this.useCustomMessage) {
            this.setText(KROWN.settings.locales.cart_custom_message.replace('{{amount}}', cartRewardsFormatMoney(Math.abs(remShipping), KROWN.settings.shop_money_format)));
          } else {
            this.setText(KROWN.settings.locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', cartRewardsFormatMoney(Math.abs(remShipping), KROWN.settings.shop_money_format)));
          }
        } else {
          this.setText(KROWN.settings.locales.cart_gift_remaining_html.replace('{{ remaining_amount }}', cartRewardsFormatMoney(Math.abs(remGift), KROWN.settings.shop_money_format)));
        }
      } else if (shippingDone && !giftDone) {
        this.setText(KROWN.settings.locales.cart_both_remaining_gift_html.replace('{{ remaining_amount }}', cartRewardsFormatMoney(Math.abs(remGift), KROWN.settings.shop_money_format)));
      } else if (giftDone && !shippingDone) {
        this.setText(KROWN.settings.locales.cart_both_remaining_shipping_html.replace('{{ remaining_amount }}', cartRewardsFormatMoney(Math.abs(remShipping), KROWN.settings.shop_money_format)));
      } else {
        this.setText(KROWN.settings.locales.cart_both_eligible);
      }
    }

    setText(html) {
      if (this.textEl) {
        this.textEl.innerHTML = html;
      }
    }

    // Punto de posición actual, relleno de la barra, estado "alcanzado" de
    // cada icono, y fase global (gris/negro/verde), todo sobre la misma
    // escala 0-100% (tMax).
    updateProgress() {
      const positionValue = this.mode === 'shipping_only' ? this.cartTotal : this.subtotal;
      const pct = this.tMax > 0 ? Math.max(0, Math.min(100, positionValue * 100 / this.tMax)) : 0;

      const giftDone = this.mode !== 'shipping_only' && positionValue >= this.tGift;
      const shippingDone = this.mode !== 'gift_only' && positionValue >= this.tShipping;

      let phase;
      if (this.mode === 'both') {
        phase = (giftDone && shippingDone) ? 'complete' : (giftDone || shippingDone) ? 'partial' : 'none';
      } else {
        phase = (giftDone || shippingDone) ? 'complete' : 'none';
      }
      this.setAttribute('data-phase', phase);

      // Al 100% no hay empuje que aplicar: es la meta, el punto se oculta
      // (ver setDotPosition) y la barra debe llegar llena, sin recortar.
      // El empuje por colisión (resolveDisplayPct) solo aplica antes de eso.
      const displayPct = pct >= 100 ? 100 : this.resolveDisplayPct(pct);
      this.setSliderWidth(displayPct);
      this.setDotPosition(displayPct, pct >= 100);

      if (this.giftIconEl) {
        this.giftIconEl.classList.toggle('cart-rewards-bar__waypoint--reached', giftDone);
      }
      if (this.shippingIconEl) {
        this.shippingIconEl.classList.toggle('cart-rewards-bar__waypoint--reached', shippingDone);
      }
    }

    // Empuja la posición real lo justo para respetar cartRewardsDotMargin
    // (puntos %) frente a cada icono presente, sin ocultar nunca el punto.
    resolveDisplayPct(rawPct) {
      let pct = rawPct;

      const iconPcts = [this.giftIconPct, this.shippingIconPct]
        .filter(iconPct => iconPct !== null)
        .sort((a, b) => a - b);

      iconPcts.forEach(iconPct => {
        if (Math.abs(pct - iconPct) < cartRewardsDotMargin) {
          pct = pct <= iconPct ? iconPct - cartRewardsDotMargin : iconPct + cartRewardsDotMargin;
        }
      });

      return Math.max(0, Math.min(100, pct));
    }

    setSliderWidth(pct) {
      if (this.sliderEl) {
        this.sliderEl.style.width = `${pct}%`;
      }
    }

    setDotPosition(pct, hide) {
      if (this.dotEl) {
        this.dotEl.style.left = `${pct}%`;
        this.dotEl.classList.toggle('cart-rewards-bar__dot--hidden', !!hide);
      }
    }

  }

  if (typeof customElements.get('cart-rewards-bar') == 'undefined') {
    customElements.define('cart-rewards-bar', CartRewardsBar);
  }

}

if (typeof CartGifting !== 'function') {

  class CartGifting extends HTMLElement {

    constructor() {
      super();
      this.initialized = false;
      this.isProcessingGift = false; // Bandera para evitar eliminación durante agregado
    }

    connectedCallback() {
      // Este método se llama cada vez que el elemento se añade al DOM
      if (!this.initialized) {
        this.init();
        this.initialized = true;
      }
    }

    init() {
      // Inicializar propiedades
      this.threshold = Number(this.getAttribute('data-threshold'));
      this.cartTotal = Number(this.getAttribute('data-cart-total'));
      this.productCards = this.querySelectorAll('.cart-gifting__product');

      // Verificar estado inicial del carrito
      this.checkCartState();

      // Escuchar actualizaciones del carrito
      this._cartUpdatedHandler = (e) => {
        setTimeout(() => this.updateCartTotal(e.detail), 100);
      };
      document.addEventListener('cart:updated', this._cartUpdatedHandler);
    }

    disconnectedCallback() {
      // Limpiar listener cuando el elemento se elimina del DOM
      if (this._cartUpdatedHandler) {
        document.removeEventListener('cart:updated', this._cartUpdatedHandler);
      }
    }


    async checkCartState() {
      // Verificación inicial: eliminar productos regalo (añadidos por el widget)
      // si no hay productos normales o el total ha caído por debajo del umbral.
      try {
        this.isProcessingGift = false;

        const response = await fetch(window.Shopify.routes.root + 'cart.js');
        const cart = await response.json();

        const cartTotalWithoutGifts = this.calculateTotalWithoutGifts(cart);
        const normalProductsCount = cart.items.filter(item =>
          !item.properties || item.properties._gift_product !== 'true'
        ).length;

        const hasGiftingProducts = cart.items.some(item =>
          item.properties && item.properties._gift_product === 'true'
        );

        const shouldRemove = hasGiftingProducts && (
          normalProductsCount === 0 ||
          cartTotalWithoutGifts < this.threshold
        );
        if (shouldRemove) {
          await this.removeAllGiftingProducts(cart);

          if (typeof refreshCart === 'function') {
            refreshCart();
          } else {
            window.location.reload();
          }
        }
      } catch (error) {
        this.isProcessingGift = false;
      }
    }

    calculateTotalWithoutGifts(cart) {
      return cart.items.reduce((total, item) => {
        if (!item.properties || item.properties._gift_product !== 'true') {
          return total + item.final_line_price;
        }
        return total;
      }, 0);
    }

    async updateCartTotal(cartDetail) {
      try {
        let cart = cartDetail;
        if (!cart || !cart.items) {
          const response = await fetch(window.Shopify.routes.root + 'cart.js');
          cart = await response.json();
        }

        const cartTotalWithoutGifts = this.calculateTotalWithoutGifts(cart);
        const normalProductsCount = cart.items.filter(item =>
          !item.properties || item.properties._gift_product !== 'true'
        ).length;

        this.setAttribute('data-cart-total', cartTotalWithoutGifts);
        this.cartTotal = cartTotalWithoutGifts;

        const hasGiftingProducts = cart.items.some(item =>
          item.properties && item.properties._gift_product === 'true'
        );

        // Auto-eliminación: solo afecta a líneas marcadas por el widget
        // (con la property _gift_product). Un producto igual añadido a mano
        // por el cliente nunca se toca ni se elimina automáticamente.
        const shouldRemove = hasGiftingProducts && (
          normalProductsCount === 0 ||
          (!this.isProcessingGift && cartTotalWithoutGifts < this.threshold)
        );

        if (shouldRemove) {
          const wasProcessing = this.isProcessingGift;
          this.isProcessingGift = true;

          await this.removeAllGiftingProducts(cart);

          this.isProcessingGift = wasProcessing;

          if (typeof refreshCart === 'function') {
            refreshCart();
          }
        }

        this.updateCardStates(cart);
      } catch (error) {
        this.isProcessingGift = false;
      }
    }

    updateCardStates(cart) {
      // Actualizar el estado de las cards según los productos en el carrito.
      // 3 copys posibles: "Añadido" (esta es la seleccionada), "Cambiar"
      // (hay otra seleccionada) o "Añadir" (todavía no hay ninguna).
      // El desplegable siempre se puede abrir; lo que se deshabilita es el
      // botón de añadir/cambiar (nunca el de quitar) hasta llegar al umbral.
      const anyGiftInCart = Array.from(this.productCards).some(card => {
        const productId = card.getAttribute('data-product-id');
        return cart.items.some(item => item.product_id == productId);
      });
      const reached = this.cartTotal >= this.threshold;

      this.productCards.forEach(card => {
        const productId = card.getAttribute('data-product-id');
        const isInCart = cart.items.some(item => item.product_id == productId);

        card.setAttribute('data-in-cart', isInCart ? 'true' : 'false');

        const cta = card.querySelector('[data-js-gift-cta]');
        if (cta) {
          cta.textContent = isInCart
            ? KROWN.settings.locales.cart_gift_added_label
            : (anyGiftInCart ? KROWN.settings.locales.cart_gift_change_button : KROWN.settings.locales.cart_gift_add_button);
          cta.disabled = !isInCart && !reached;
        }
      });
    }

    async handleCardClick(event, card) {
      // Prevenir múltiples clicks
      if (this.isProcessingGift) {
        return;
      }

      const isInCart = card.getAttribute('data-in-cart') === 'true';
      const variantId = card.getAttribute('data-variant-id');
      const productId = card.getAttribute('data-product-id');

      card.style.opacity = '0.6';
      card.style.cursor = 'wait';

      this.isProcessingGift = true;

      try {
        const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
        const cart = await cartResponse.json();

        // Si el producto YA está en el carrito (con o sin la property, ver
        // removeGiftingProduct) → ELIMINARLO. Si no está → AGREGAR (quitando
        // primero cualquier otro regalo, solo se permite 1 a la vez).
        if (isInCart) {
          await this.removeGiftingProduct(cart, productId, variantId);
        } else {
          await this.removeAllGiftingProducts(cart);
          await this.addGiftingProduct(variantId);
        }

        card.style.opacity = '1';
        card.style.cursor = 'pointer';

        this.isProcessingGift = false;

        document.dispatchEvent(new CustomEvent('cart:updated'));

        if (typeof refreshCart === 'function') {
          refreshCart();
        } else {
          window.location.reload();
        }

      } catch (error) {
        this.isProcessingGift = false;
        card.style.opacity = '1';
        card.style.cursor = 'pointer';
        alert('Error: ' + error.message);
      }
    }

    async removeGiftingProduct(cart, productId, variantId) {
      // El botón "Cambiar" debe eliminar la línea aunque el producto se haya
      // añadido a mano (sin la property _gift_product): primero se busca la
      // línea marcada por el widget, luego la misma variante, y por último
      // cualquier línea de ese mismo producto.
      const giftItem =
        cart.items.find(item => item.product_id == productId && item.properties && item.properties._gift_product === 'true') ||
        cart.items.find(item => item.product_id == productId && item.variant_id == variantId) ||
        cart.items.find(item => item.product_id == productId);

      if (giftItem) {
        const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: giftItem.key,
            quantity: 0
          })
        });

        if (!response.ok) {
          throw new Error('Error al eliminar el regalo');
        }
      }
    }

    async removeAllGiftingProducts(cart) {
      // Solo elimina líneas marcadas por el widget (_gift_product) — nunca
      // toca un producto igual añadido a mano por el cliente.
      const giftItems = cart.items.filter(item =>
        item.properties && item.properties._gift_product === 'true'
      );

      for (const item of giftItems) {
        await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: item.key,
            quantity: 0
          })
        });
      }
    }

    async addGiftingProduct(variantId) {
      const formData = {
        'items': [{
          'id': Number(variantId),
          'quantity': 1,
          'properties': {
            '_gift_product': 'true'
          }
        }]
      };

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        const result = await response.json();
        const errorMsg = result.description || result.message || 'Error al añadir el regalo';
        throw new Error(errorMsg);
      }
    }

  }

  if (typeof customElements.get('cart-gifting') == 'undefined') {
    customElements.define('cart-gifting', CartGifting);
  }

  // Delegación de eventos: capturar clics en el CTA de añadir/cambiar,
  // aunque el elemento se reinserte dinámicamente al refrescar el carrito.
  document.addEventListener('click', (e) => {
    const cta = e.target.closest('[data-js-gift-cta]');
    const card = cta ? cta.closest('.cart-gifting__product') : null;
    if (card) {
      const cartGifting = card.closest('cart-gifting');
      if (cartGifting && typeof cartGifting.handleCardClick === 'function') {
        e.preventDefault();
        cartGifting.handleCardClick(e, card);
      }
    }
  });

  // Popup "Mostrar detalles" (Diseño 2): delegación global, un único modal
  // compartido rellenado con los data-detail-* de la card clicada.
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-js-gift-details]');
    if (!trigger || trigger.classList.contains('cart-gifting__details-link--hidden')) return;

    e.preventDefault();

    const modal = document.getElementById('cart-gift-detail-modal');
    if (!modal) return;

    const card = trigger.closest('.cart-gifting__product');
    const isInCart = card && card.getAttribute('data-in-cart') === 'true';
    const anyGiftInCart = !!document.querySelector('.cart-gifting__product[data-in-cart="true"]');
    const cardCta = card && card.querySelector('[data-js-gift-cta]');

    modal.querySelector('[data-js-gift-detail-title]').textContent = trigger.dataset.detailTitle || '';
    modal.querySelector('[data-js-gift-detail-image]').src = trigger.dataset.detailImage || '';
    modal.querySelector('[data-js-gift-detail-text]').textContent = trigger.dataset.detailText || '';

    const cta = modal.querySelector('[data-js-gift-detail-cta]');
    cta.textContent = isInCart
      ? KROWN.settings.locales.cart_gift_added_label
      : (anyGiftInCart ? KROWN.settings.locales.cart_gift_change_button : KROWN.settings.locales.cart_gift_add_button);
    // Mismo estado deshabilitado que la card (mostrar detalles siempre se
    // puede ver; añadir/cambiar no, hasta llegar al umbral).
    cta.disabled = !!(cardCta && cardCta.disabled);
    cta.onclick = () => {
      const cartGifting = card.closest('cart-gifting');
      if (cartGifting && card) {
        cartGifting.handleCardClick(null, card);
      }
      modal.hide();
    };

    modal.show();
  });

}
